<template>
    <div class="container">
        <div class="row faqs mx-auto mb-5 pb-5">
            <div class="col-md-12">
                <h1 class="text-center mt-5 mb-5">
                    {{ $t('Support.SupportTitle') }}
                </h1>

                <div class="accordion" id="faqAccordion">
                    <div class="card" v-for="(faq, index) in faqs" :key="index" :class="{ active: activeIndex === index }">
                        <div class="card-header" :id="'heading' + index">
                            <h2 class="accordion-header">
                                <button :class="{
                    'arrow-open': activeIndex === index,
                    'arrow-closed': activeIndex !== index,
                  }"
                                        class="accordion-button"
                                        type="button"
                                        @click="toggle(index)"
                                        :aria-expanded="activeIndex === index ? 'true' : 'false'"
                                        :aria-controls="'collapse' + index">
                                    {{ faq.question }}
                                </button>
                            </h2>
                        </div>
                        <div :id="'collapse' + index"
                             class="accordion-collapse collapse"
                             :class="{ show: activeIndex === index }"
                             :aria-labelledby="'heading' + index"
                             data-bs-parent="#faqAccordion">
                            <div class="card-body" v-html="faq.answer"></div>
                        </div>
                    </div>
                </div>

              
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FAQ',
        data() {
            return {
                faqs: [],
                activeIndex: null,
                targetFaqKeyword: 'heading2',
            };
        },
        created() {
            this.loadFaqs();
        },
      mounted() {
    // Open based on URL hash
    const hash = window.location.hash.replace('#', ''); // removes the #
    if (hash) {
        this.targetFaqKeyword = hash;
        this.$nextTick(() => {
            this.openTargetFaq();
        });
    }

    // Open first FAQ on any link click inside this component
    this.$nextTick(() => {
        const links = this.$el.querySelectorAll('a');
        links.forEach((link) => {
            link.addEventListener('click', () => {
                this.activeIndex = 0;
            });
        });
    });
},
        watch: {
            '$i18n.locale': 'loadFaqs',
        },
        methods: {
            async loadFaqs() {
                try {
                    const currentLocale = this.$i18n.locale;
                    const response = await fetch(`/locales/${currentLocale}.json`);
                    const data = await response.json();

                    if (data && data.Support) {
                        this.faqs = data.Support.faqs;
                    } else {
                        console.error('Invalid FAQ data structure in', currentLocale);
                        this.faqs = [];
                    }
                } catch (error) {
                    console.error('Error loading FAQs:', error);
                    this.faqs = [];
                }
            },
            toggle(index) {
                this.activeIndex = this.activeIndex === index ? null : index;
            },
            async openTargetFaq() {
    if (this.faqs.length === 0) {
        await this.loadFaqs();
    }

    const hash = this.targetFaqKeyword.toLowerCase(); // e.g. "heading2"
    const indexMatch = hash.match(/heading(\d+)/);    // extract number → "2"

    if (indexMatch) {
        this.activeIndex = parseInt(indexMatch[1]);   // set index directly → 2
    } else {
        this.activeIndex = 0;
    }

    this.$nextTick(() => {
        const el = document.getElementById(`heading${this.activeIndex}`);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
},
        },
    };
</script>


